import * as firebase from '@firebase/app'
import '@firebase/messaging'
import '@firebase/analytics'
import $bus from './../_eventBus'
import path from 'path'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STIRAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}

export const registerMessageFirebase = async () => {
  try {
    firebase.initializeApp(firebaseConfig)
    const messaging = firebase.messaging()

    const saveTokenFirebase = (str) => {
      const tokenFirebaseStorage = {
        token: str,
        isRegister: false
      }
      localStorage.setItem(
        'token_firebase',
        JSON.stringify(tokenFirebaseStorage)
      )
    }

    messaging.usePublicVapidKey(process.env.VUE_APP_FIREBASE_KEY_PAIR)
    await messaging.requestPermission()

    const registration = await navigator.serviceWorker.register(
      path.join(__dirname, 'static', 'firebase-messaging-sw.js')
    )
    messaging.useServiceWorker(registration)
    let tokenFirebase = JSON.parse(localStorage.getItem('token_firebase'))
    let token = await messaging.getToken()
    if ((tokenFirebase && tokenFirebase.token !== token) || !tokenFirebase) {
      saveTokenFirebase(token)
    }

    messaging.onMessage((payload) => {
      $bus.$emit('pushNotification', payload)
    })
  } catch (error) {
    console.error(error.message)
  }
}



// WEBPACK FOOTER //
// ./src/firebase/config.js